import { MemoryStorage, AppStates } from '@Engage.Core';
import { OptionsModel } from './OptionsModel';
import { generateGuid } from '@Engage.Core';
import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
import { StorageKeys } from '@Engage.Data/constants/Constants';
class AppOptionsClass {
    constructor() {
        this.pageSessionId = generateGuid();
    }
    init(options) {
        this.options = new OptionsModel(options);
        // Apply debug panel custom config override immediately during init
        // (mirrors ConneXt v2 DebugConfiguration.setCustomAppConfig called before config load)
        try {
            const raw = localStorage.getItem('Connext_Configuration_isCustom');
            const isCustom = raw ? JSON.parse(raw) : false;
            if (isCustom) {
                const rawSite = localStorage.getItem('Connext_Configuration_SiteCode');
                const rawConfig = localStorage.getItem('Connext_Configuration_ConfigCode');
                console.log('[AppOptions] Raw localStorage values:', { raw, rawSite, rawConfig });
                const customSite = rawSite ? JSON.parse(rawSite) : null;
                const customConfig = rawConfig ? JSON.parse(rawConfig) : null;
                if (customSite)
                    this.options.siteCode = String(customSite).toUpperCase();
                if (customConfig)
                    this.options.configCode = String(customConfig).toUpperCase();
                console.log('[AppOptions] Debug custom config override applied:', 'siteCode=' + this.options.siteCode, 'configCode=' + this.options.configCode);
            }
        }
        catch (e) {
            console.error('[AppOptions] Custom config override error:', e);
        }
        // Store whole instance like old project
        MemoryStorage.set(AppStates.AppOptions, this);
        // Ensure BrowserSessionId is persisted across pages (like ConneXt v2)
        this.initBrowserSessionId();
    }
    initBrowserSessionId() {
        if (!this.getBrowserSessionId()) {
            localStorageService.set(StorageKeys.BrowserSessionId, generateGuid(), { expandKey: false });
        }
    }
    getBrowserSessionId() {
        var _a;
        return (_a = localStorageService.get(StorageKeys.BrowserSessionId, { expandKey: false })) !== null && _a !== void 0 ? _a : null;
    }
    /** New GUID per page load — matches ConneXt v2 AppOptions.getSessionId() */
    getPageSessionId() {
        return this.pageSessionId;
    }
    getOptions() {
        return this.options;
    }
    get(key) {
        return this.options[key];
    }
    getEnvironment() {
        return this.options.environment;
    }
    getApiUrl() {
        return this.options.apiUrl;
    }
    getSiteCode() {
        return this.options.siteCode;
    }
    getConfigCode() {
        return this.options.configCode;
    }
    /** Override site code at runtime — used by debug panel custom config (mirrors ConneXt v2 AppOptions.setSiteCode) */
    setSiteCode(siteCode) {
        if (siteCode) {
            this.options.siteCode = siteCode.toUpperCase();
        }
    }
    /** Override config code at runtime — used by debug panel custom config (mirrors ConneXt v2 AppOptions.setConfigCode) */
    setConfigCode(configCode) {
        if (configCode) {
            this.options.configCode = configCode.toUpperCase();
        }
    }
    getClientCode() {
        return this.options.clientCode;
    }
    getSettingsKey() {
        return this.options.settingsKey;
    }
    getAttr() {
        return this.options.attr;
    }
    getProductCode() {
        return this.options.productCode;
    }
    getPaperCode() {
        return this.options.paperCode;
    }
    getResourceUrl() {
        return this.options.resourceUrl || null;
    }
}
export const AppOptions = new AppOptionsClass();
